module.exports = __webpack_public_path__ + "img/left1Icon1.22744677.png";